import { Stack, Switch, Tooltip, Typography } from '@mui/material';
import React from 'react';

const toggleConfig = [
  { field: 'isInternal', label: 'Internal', shortLabel: 'INT' },
  { field: 'isProduction', label: 'Production', shortLabel: 'PROD' },
  { field: 'isOwned', label: 'Owned', shortLabel: 'OWN' },
];

const ClusterSettingsInline = ({ cluster, onToggle, disabled }) => {
  if (!cluster) {
    return null;
  }

  const getFieldValue = (field) => {
    const displayKey = `display${field.charAt(0).toUpperCase()}${field.slice(1)}`
    if (Object.prototype.hasOwnProperty.call(cluster, displayKey)) {
      return cluster[displayKey]
    }
    return cluster[field]
  }

  const handleToggle = (field, checked) => {
    if (typeof onToggle === 'function') {
      onToggle({
        clusterName: cluster.clusterName,
        fieldName: field,
        fieldValue: checked,
      });
    }
  };

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
      {toggleConfig.map(({ field, label, shortLabel }) => (
        <Tooltip title={label} key={field}>
          <Stack spacing={0.5} alignItems="center">
            <Typography variant="caption" sx={{ fontSize: 11, fontWeight: 600 }}>
              {shortLabel}
            </Typography>
            <Switch
              size="small"
              checked={Boolean(getFieldValue(field))}
              onChange={(event) => handleToggle(field, event.target.checked)}
              disabled={disabled}
              inputProps={{ 'aria-label': `${label} toggle for ${cluster.clusterName}` }}
            />
          </Stack>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default ClusterSettingsInline;
